import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Rocket } from 'lucide-react';
import { MixedText } from '../utils/rtl';
import { LoadingSpinner } from './ui/LoadingSpinner';

const CreateSession: React.FC = () => {
  const { t, i18n } = useTranslation();
  const isRTL = i18n.language === 'he';
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    // Check for course_id parameter in URL
    const courseId = searchParams.get('course_id');
    
    // Determine target URL based on presence of course_id
    const targetUrl = courseId 
      ? `/quick/create-study-session?course_id=${courseId}`
      : '/quick/create-study-session';
    
    // Redirect with replace to avoid back button issues
    navigate(targetUrl, { replace: true });
  }, [navigate, searchParams]);

  // Show loading spinner while redirecting
  return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="text-center space-y-4">
        <LoadingSpinner size="lg" />
        <div className={`space-y-2 ${isRTL ? 'text-right' : 'text-left'}`}>
          <div className={`flex items-center justify-center ${isRTL ? 'flex-row-reverse' : ''}`}>
            <Rocket className="w-6 h-6 text-vibrant-orange mr-2 ml-2" />
            <h2 className="text-lg font-semibold text-surface-primary font-hebrew">
              <MixedText>{t('sessions:create.title')}</MixedText>
            </h2>
          </div>
          <p className="text-surface-secondary font-hebrew">
            <MixedText>{t('common:status.loading')}</MixedText>
          </p>
        </div>
      </div>
    </div>
  );
};

export default CreateSession; 